import {
  SearchExperiencesResponse,
  CursorSearch,
} from './src/table-reservations-v1-experience-experiences.universal';

export * from './src/table-reservations-v1-experience-experiences.universal.js';

/** @hidden */
export type ExperienceSearch = {};

/**
 * Use this method to search the fields of the experiences on a site for a given expression.
 *
 * You can also use this method to perform data aggregations on a site's experience fields.
 * @param search - Search query.
 * @public
 * @requiredField search
 * @permissionId TABLE_RESERVATIONS.EXPERIENCE_READ
 * @applicableIdentity APP
 * @fqn wix.table_reservations.experience.v1.ExperiencesService.SearchExperiences
 */
export declare function searchExperiences(
  search: CursorSearch
): Promise<SearchExperiencesResponse>;
